
export default function ProgramFlow() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 mb-20">
          <div className="flex flex-col items-center">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-full border-2 border-gray-900 flex items-center justify-center">
              <p className="text-2xl md:text-3xl font-light text-gray-900">運動</p>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <i className="ri-arrow-right-line text-3xl md:text-4xl text-gray-400 rotate-90 md:rotate-0"></i>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-full border-2 border-gray-900 flex items-center justify-center">
              <p className="text-2xl md:text-3xl font-light text-gray-900">リズム</p>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <i className="ri-arrow-right-line text-3xl md:text-4xl text-gray-400 rotate-90 md:rotate-0"></i>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-full border-2 border-gray-900 flex items-center justify-center">
              <p className="text-2xl md:text-3xl font-light text-gray-900">振付</p>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <i className="ri-arrow-right-line text-3xl md:text-4xl text-gray-400 rotate-90 md:rotate-0"></i>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-full border-2 border-gray-900 flex items-center justify-center">
              <p className="text-2xl md:text-3xl font-light text-gray-900">表現</p>
            </div>
          </div>
        </div>
        
        <p className="text-base md:text-lg font-light text-gray-600 text-center leading-[1.8]">
          身体を鍛えながら、<br />
          自然にダンスへ入る設計です。
        </p>
      </div>
    </section>
  );
}
